// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: 4fKk19rlQyRiU
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Navbar from "../../Navbar"; // plasmic-import: 5Pxe45fpZL/component
import ProjectCreation from "../../ProjectCreation"; // plasmic-import: 8p50CBe8Ah/component
import ProjectCard from "../../ProjectCard"; // plasmic-import: AgdF0DgOMW/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: 4fKk19rlQyRiU/css

export type PlasmicHomepage__VariantMembers = {};

export type PlasmicHomepage__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomepage__VariantsArgs;
export const PlasmicHomepage__VariantProps = new Array<VariantPropType>();

export type PlasmicHomepage__ArgsType = {};
type ArgPropType = keyof PlasmicHomepage__ArgsType;
export const PlasmicHomepage__ArgProps = new Array<ArgPropType>();

export type PlasmicHomepage__OverridesType = {
  root?: p.Flex<"div">;
  navbar?: p.Flex<typeof Navbar>;
  projectCreationContainer?: p.Flex<"div">;
  projectCreation?: p.Flex<typeof ProjectCreation>;
  projects?: p.Flex<"div">;
  text?: p.Flex<"div">;
  projectContainer?: p.Flex<"div">;
  toastify?: p.Flex<"div">;
};

export interface DefaultHomepageProps {
  className?: string;
}

function PlasmicHomepage__RenderFunc(props: {
  variants: PlasmicHomepage__VariantsArgs;
  args: PlasmicHomepage__ArgsType;
  overrides: PlasmicHomepage__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <React.Fragment>
      {}

      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          sty.root
        )}
      >
        <Navbar
          data-plasmic-name={"navbar"}
          data-plasmic-override={overrides.navbar}
          className={classNames("__wab_instance", sty.navbar)}
        />

        <div
          data-plasmic-name={"projectCreationContainer"}
          data-plasmic-override={overrides.projectCreationContainer}
          className={classNames(projectcss.all, sty.projectCreationContainer)}
        >
          <ProjectCreation
            data-plasmic-name={"projectCreation"}
            data-plasmic-override={overrides.projectCreation}
            className={classNames("__wab_instance", sty.projectCreation)}
          />
        </div>

        <div
          data-plasmic-name={"projects"}
          data-plasmic-override={overrides.projects}
          className={classNames(projectcss.all, sty.projects)}
        >
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text
            )}
          >
            {"Projects"}
          </div>

          <p.Stack
            as={"div"}
            data-plasmic-name={"projectContainer"}
            data-plasmic-override={overrides.projectContainer}
            hasGap={true}
            className={classNames(projectcss.all, sty.projectContainer)}
          >
            <ProjectCard
              className={classNames("__wab_instance", sty.projectCard__yzR1)}
            />

            <ProjectCard
              className={classNames("__wab_instance", sty.projectCard__fLdzo)}
            />

            <ProjectCard
              className={classNames("__wab_instance", sty.projectCard__xnbyS)}
            />

            <ProjectCard
              className={classNames("__wab_instance", sty.projectCard__vTudz)}
            />

            <ProjectCard
              className={classNames("__wab_instance", sty.projectCard__vxDgS)}
            />

            <ProjectCard
              className={classNames("__wab_instance", sty.projectCard__aanSg)}
            />
          </p.Stack>
        </div>

        <div
          data-plasmic-name={"toastify"}
          data-plasmic-override={overrides.toastify}
          className={classNames(projectcss.all, sty.toastify)}
        />
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "navbar",
    "projectCreationContainer",
    "projectCreation",
    "projects",
    "text",
    "projectContainer",
    "toastify"
  ],
  navbar: ["navbar"],
  projectCreationContainer: ["projectCreationContainer", "projectCreation"],
  projectCreation: ["projectCreation"],
  projects: ["projects", "text", "projectContainer"],
  text: ["text"],
  projectContainer: ["projectContainer"],
  toastify: ["toastify"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  navbar: typeof Navbar;
  projectCreationContainer: "div";
  projectCreation: typeof ProjectCreation;
  projects: "div";
  text: "div";
  projectContainer: "div";
  toastify: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomepage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomepage__VariantsArgs;
    args?: PlasmicHomepage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicHomepage__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicHomepage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navbar: makeNodeComponent("navbar"),
    projectCreationContainer: makeNodeComponent("projectCreationContainer"),
    projectCreation: makeNodeComponent("projectCreation"),
    projects: makeNodeComponent("projects"),
    text: makeNodeComponent("text"),
    projectContainer: makeNodeComponent("projectContainer"),
    toastify: makeNodeComponent("toastify"),

    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,

    // Page metadata
    pageMetadata: {
      title: "Home",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
